// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3-uxP","content":"styles_content__1LN7l","selectAll":"styles_selectAll__cejej"};